import * as React from 'react';
import LaunchIcon from '@mui/icons-material/Launch';
import _ from 'lodash';

import { Appointment, Container } from 'types/Watchlist';
import moment from 'moment';
import DisplayAppointmentsModal from '../../../../DisplayAppointmentsModal';
import { DateRange } from '../DateRange';

interface Props {
  container: Container;
  appointment: Appointment;
}

/**
 * @param props
 * @returns
 */
export const Book: React.FC<Props> = (props) => {
  const { container, appointment } = props;
  const { pickupInfo } = container;
  const [modalIsOpen, setModalIsOpen] = React.useState(false);

  const slots = (appointment.availablePickupAppointment?.availableSlots || []).map((a) => ({
    periodFromDate: moment(a.slotStart).tz(appointment?.availablePickupAppointment?.timezone || ''),
    periodToDate: moment(a.slotEnd).tz(appointment?.availablePickupAppointment?.timezone || ''),
    slots: a.appointmentsAvailable,
    shiftId: a.shiftId,
  }));
  const firstAppointment = _.head(slots);
  if (
    appointment.availablePickupAppointment &&
    !firstAppointment &&
    !appointment.availablePickupAppointment.scraperError
  ) {
    return <h6 className="uppercase text-red-900">No Available Appt.</h6>;
  }
  return (
    <>
      {pickupInfo && !!pickupInfo.terminalAppointmentSystemLink && (
        <a
          href={pickupInfo.terminalAppointmentSystemLink}
          target="_blank"
          className="flex items-center underline text-blue-900 space-x-1"
          rel="noreferrer"
        >
          <h6 className="uppercase font-medium">Book Appt.</h6>
          <LaunchIcon style={{ fontSize: 10 }} />
        </a>
      )}
      {firstAppointment && (
        <div className="flex space-x-0.5">
          <h6 className="uppercase">First Available: </h6>
          <DateRange start={firstAppointment.periodFromDate} end={firstAppointment.periodToDate} />
        </div>
      )}
      {pickupInfo && firstAppointment && slots.length > 1 && (
        <>
          <h6
            className="text-blue-900 underline cursor-pointer"
            onClick={() => setModalIsOpen(true)}
          >
            See others
          </h6>
          <DisplayAppointmentsModal
            open={modalIsOpen}
            onClose={() => setModalIsOpen(false)}
            containerStatus={container.status}
            containerType={container.containerType}
            shippingLine={container.shippingLine}
            containerNumber={container.containerNumber}
            appointments={slots}
            title="All Pickup Appointments for"
            appointementSystemUrl={pickupInfo.terminalAppointmentSystemLink}
            terminalName={pickupInfo.terminalName}
          />
        </>
      )}
    </>
  );
};
Book.displayName = 'PickupCell.Book';
